import { render, staticRenderFns } from "./tagText.vue?vue&type=template&id=2e75323c&scoped=true"
import script from "./tagText.vue?vue&type=script&lang=js"
export * from "./tagText.vue?vue&type=script&lang=js"
import style0 from "./tagText.vue?vue&type=style&index=0&id=2e75323c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e75323c",
  null
  
)

export default component.exports